import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import modalComponents from 'registry/modalComponents';

const Wrapper = styled.div`
  padding: 20px;

  .not-found {
    margin: 40px 0;
    text-align: center;
  }
`;

/* eslint-disable react/prefer-stateless-function */
@inject('uiStore')
@observer
class ModalContent extends Component {
  static propTypes = {
    uiStore: PropTypes.object.isRequired,
  };

  render() {
    const { uiStore } = this.props;

    const modalComponent = modalComponents[uiStore.modalContent];

    if (!modalComponent) {
      return (
        <Wrapper>
          <div className="not-found">
            <h3>Content not found.</h3>
          </div>
        </Wrapper>
      );
    }

    const modalContent = React.createElement(modalComponent);

    return <Wrapper>{modalContent}</Wrapper>;
  }
}

export default ModalContent;
